import { useState, useEffect, useRef } from "react";
import { ScoreBoardRes, UpdatedScoreBoardRes } from "../../models/scoreCard";

const useGetScoringData = (matchId, matchOperations) => {
  const [scoreData, setScoreData] = useState();
  const [loading, setLoading] = useState(true);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isDuck, setIsDuck] = useState(false);
  const isUnmounted = useRef(false);

  const fetchData = () => {
    // debgging

    const es = new EventSource(
      `https://apiuat.jccsprts.com/api/v1/sse/subscribe-sse/match/${matchId}/`,
      { debug: true }
    );

    es.addEventListener("open", (event) => {});

    es.addEventListener("message", (event) => {
      let parsedData = JSON.parse(event?.data);

      if (JSON.parse(parsedData)?.inningCompleted) {
        // Above empty if block is to prevent crashing
        setIsDuck(false);
      } else if (JSON.parse(parsedData)?.newInningStarted) {
        es.close();
        fetchData();
        setIsDuck(false);
      } else if (JSON.parse(parsedData)?.matchCompleted) {
        setIsDuck(false);
        setScoreData((prevScoreData) => {
          let scoreBoardRes = new ScoreBoardRes(
            prevScoreData,
            JSON.parse(parsedData)
          );
          return scoreBoardRes;
        });
        es.close();
        fetchData();
        matchOperations.refetchMatchDetails();
        matchOperations.switchToSummary();
      } else if (JSON.parse(parsedData)?.isInitialConnection) {
        let scoreBoardRes = new ScoreBoardRes(JSON.parse(parsedData)?.data);
        setScoreData(scoreBoardRes);
        setIsDuck(false);
      } else if (JSON.parse(parsedData)?.isDuck) {
        //
        setIsDuck(true);
      } else if (JSON.parse(parsedData)?.event === "new-super-over-started") {
        es.close();
        fetchData();
        setIsDuck(false);
      } else {
        setIsDuck(false);
        setScoreData((prevScoreData) => {
          const updatedScoreBoardRes = new UpdatedScoreBoardRes(
            prevScoreData,
            JSON.parse(parsedData)
          );
          return updatedScoreBoardRes?.updatedScoreBoard;
        });
      }

      setLoading(false);
      setIsRefetching(false);
    });

    es.addEventListener("error", (event) => {
      if (event.type === "error") {
      } else if (event.type === "exception") {
      }
    });

    es.addEventListener("close", (event) => {
      if (!isUnmounted) {
        setIsRefetching(true);
        fetchData();
      }
    });

    return es;
  };

  useEffect(() => {
    const eventSource = fetchData();
    isUnmounted.current = false;
    return () => {
      isUnmounted.current = true;
      eventSource?.close();
    };
  }, []); // Empty dependency array to ensure this effect runs only once

  return {
    scoreData,
    loading,
    isRefetching,
    isDuck,
  };
};

export default useGetScoringData;
